module.exports = __webpack_public_path__ + "static/img/weather36.b5440c68.png";